import script from "./Keys.vue?vue&type=script&setup=true&lang=js"
export * from "./Keys.vue?vue&type=script&setup=true&lang=js"

import "./Keys.vue?vue&type=style&index=0&id=1306cb02&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1306cb02"]])

export default __exports__